import _get from 'lodash/get';

const getFeatureFlags = () => {
  const { featureFlags } = window.Grab.config;
  return featureFlags;
};

export const enableEnterpriseApiDeprecation = () =>
  Boolean(_get(getFeatureFlags(), 'enableEnterpriseApiDeprecation', false));

export const enablePaySdkScope = () =>
  Boolean(_get(getFeatureFlags(), 'enablePaySdkScope', false));

export default getFeatureFlags;
